import "core-js/modules/es.array.reverse.js";
var _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { observable, makeObservable } from "mobx";
import MappableMixin, { ImageryParts } from "../../ModelMixins/MappableMixin";
export function isProviderCoords(obj) {
  if (obj) {
    return Number.isFinite(obj.x) && Number.isFinite(obj.y) && Number.isFinite(obj.level);
  } else return false;
}
export function isProviderCoordsMap(obj) {
  return Object.keys(obj).every(url => isProviderCoords(obj[url]));
}

/**
 * Holds the vector and raster features that the user picked by clicking the mouse on the map.
 */
let PickedFeatures = (_class = class PickedFeatures {
  constructor() {
    /**
     * Gets or sets a promise that indicates, when it resolves, that all picked features are available in the
     * {@see PickedFeatures#features} array.
     */
    _defineProperty(this, "allFeaturesAvailablePromise", void 0);
    /**
     * Gets or sets a value indicating whether the list of picked features is still loading.
     */
    _initializerDefineProperty(this, "isLoading", _descriptor, this);
    /**
     * Gets or sets the ground position that was picked, if any.
     */
    _defineProperty(this, "pickPosition", void 0);
    /**
     * Gets or sets the array of picked features.  The array is observable and may be updated up until the point that
     * {@see PickedFeatures#allFeaturesAvailablePromise} resolves.
     */
    _initializerDefineProperty(this, "features", _descriptor2, this);
    /**
     * Gets or sets a message describing an error that occurred while picking features.
     * If this property is undefined, no error occurred.
     * @type {String}
     */
    _initializerDefineProperty(this, "error", _descriptor3, this);
    _defineProperty(this, "providerCoords", void 0);
    makeObservable(this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "isLoading", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "features", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "error", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { PickedFeatures as default };
export function featureBelongsToCatalogItem(feature, catalogItem) {
  var _feature$entityCollec, _feature$imageryLayer;
  if (feature._catalogItem === catalogItem) return true;
  if (!MappableMixin.isMixedInto(catalogItem)) return;
  const dataSource = (_feature$entityCollec = feature.entityCollection) === null || _feature$entityCollec === void 0 ? void 0 : _feature$entityCollec.owner;
  const imageryProvider = (_feature$imageryLayer = feature.imageryLayer) === null || _feature$imageryLayer === void 0 ? void 0 : _feature$imageryLayer.imageryProvider;

  // Test whether the catalog item has a matching dataSource or an imageryProvider
  const match = catalogItem.mapItems.some(mapItem => {
    if (dataSource && mapItem === dataSource) {
      return true;
    }
    if (imageryProvider && ImageryParts.is(mapItem) && mapItem.imageryProvider === imageryProvider) {
      return true;
    }
    return false;
  });
  return match;
}